import { createRoot } from 'react-dom/client';
import type { Root } from 'react-dom/client';
import type { ComponentType } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import Modal from 'components/partials/modal/modal';
import queryClient from 'utils/query-client';
import { InsightProvider } from 'components/partials/insight-modal/insight-context';

const MODAL_CONTAINER = document.getElementById('modal-container');
let modalRoot: Root | null = null;

export type ModalProps = Record<string, unknown>;

const ModalAsAny = Modal as unknown as ComponentType<ModalProps>;

export const renderModal = (props: ModalProps): void => {
  if (!modalRoot) {
    if (!MODAL_CONTAINER) return;
    modalRoot = createRoot(MODAL_CONTAINER);
  }
  modalRoot.render(
    <QueryClientProvider client={queryClient}>
      <InsightProvider>
        <ModalAsAny {...props} />
      </InsightProvider>
    </QueryClientProvider>
  );
};

export const unmountModal = (): void => {
  if (modalRoot) {
    modalRoot.unmount();
    modalRoot = null;
  }
};
